import { render, staticRenderFns } from "./TitleAdd.vue?vue&type=template&id=6b667910&"
import script from "./TitleAdd.vue?vue&type=script&lang=js&"
export * from "./TitleAdd.vue?vue&type=script&lang=js&"
import style0 from "./TitleAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports